import action from "../action";
export const SET_SOCKET = "SET_SOCKET";
export const SET_VIEWER_WEB_URL = "SET_VIEWER_WEB_URL";
export const SET_WEB_URL = "SET_WEB_URL";
export const SET_BRANCHLINK_VIEER = "SET_BRANCHLINK_VIEER";
export const TOGGLE_HOW_TO_PLAY = "TOGGLE_HOW_TO_PLAY";
export const BNG_VOLUME = "BNG_VOLUME";
export const SET_ACTIVE_GAME = "SET_ACTIVE_GAME";
export const SET_PRICING_PAGE = "SET_PRICING_PAGE";
export const SET_MAGIC_LINK = "SET_MAGIC_LINK";
export const SET_EDITIONS = "SET_EDITIONS";
export const SET_INVITED_PLAYERS = "SET_INVITED_PLAYERS";
export const SET_CHALLENGES_COMPONENT = "SET_CHALLENGES_COMPONENT";
export const SET_LT_PARAMETERS = "SET_LT_PARAMETERS";

export const setSocket = (data) =>
  action({
    type: SET_SOCKET,
    data
  });
export const toggleHowToPlay = (data) =>
  action({
    type: "TOGGLE_HOW_TO_PLAY",
    data
  });
export const setMagicLink = (data) =>
  action({
    type: "SET_MAGIC_LINK",
    data
  });
export const toggleSlideKickQR = (data) =>
  action({
    type: "TOGGLE_SLIDEKICK_QR",
    data
  });
export const togglePlayAgain = (data) =>
  action({
    type: "TOGGLE_PLAY_AGAIN",
    data
  });
export const set_active_game = (data) =>
  action({
    type: "SET_ACTIVE_GAME",
    data
  });
export const setVolumeLevel = (data) =>
  action({
    type: "BNG_VOLUME",
    data
  });
export const setEditions = (data) =>
  action({
    type: "SET_EDITIONS",
    data
  });
export const setInvitedPlayers = (data) =>
  action({
    type: "SET_INVITED_PLAYERS",
    data
  });
export const setChallengesComponent = (data) =>
  action({
    type: "SET_CHALLENGES_COMPONENT",
    data
  });
export const setLTparameters = (data) =>
  action({
    type: "SET_LT_PARAMETERS",
    data
  });
